import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../Assets/logo.svg";
import { useNavigate } from "react-router-dom";
import { sendOTP } from "../../Services/LoginApi";
import Grid from "@mui/material/Grid2";

const ForgetPwd: React.FC = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value.trim()) {
      setEmailError("Please enter an email address");
    } else if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    const result = await sendOTP(email);
    if (result.error) {
      toast.error(result.error);
    }else{
    navigate("/verify-otp", { state: { email: email } });
    toast.success(`Password reset OTP sent to ${email}`);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto", overflowX:'hidden' }}>
      <Grid container spacing={2} className="login">
        <Grid
          size={{ xs: 12, md: 5, sm: 12 }}
          className="login__left"
          sx={{ display: { xs: "none", sm: "none", md: "flex" } }}
        >
          <div className="login__left-image">
            <img src={logo} alt="logo" />
          </div>

          <div className="login__left-title">
            <p>The Nation Paywall and Lightbox Management Portal</p>
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 7, sm: 12 }} className="login__right">
          <div className="login__container login_main">
            <Grid
              size={{ xs: 12, md: 5, sm: 12 }}
              className="login__left"
              sx={{ display: { xs: "block", sm: "block", md: "none" } }}
            >
              <div className="login__left-image">
                <img src={logo} alt="logo" />
              </div>
              <div className="login__left-title">
                <p>Experience Management Portal</p>
              </div>
            </Grid>

            <h1> Forgot Password</h1>
            <div className="mb-4">
              <p className="mb-4">
                Please Enter your registered email address.
              </p>
              <p>we'll send you a code to reset your password </p>
            </div>

            <form className="login__form">
              <TextField
                className="primary-focused-textfield"
                label="Email"
                value={email}
                type="email"
                variant="standard"
                onChange={handleEmailChange}
                error={!!emailError}
                helperText={emailError}
                fullWidth
                sx={{ mb: 2 }}
              />
              <div className="login__button">
                <Button onClick={handleResetPassword} variant="contained">
                  Send Code
                </Button>
              </div>
            </form>
          </div>
          <ToastContainer position="top-right" autoClose={3000} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ForgetPwd;
